import { useTranslation } from 'react-i18next';
import { LogisticsCalculationStatus } from '@magimp/shared';
import { StatusBadge } from '../../../ui/index.js';

export function LogisticsCalculationStatusBadge({
  status,
  size,
}: {
  status: LogisticsCalculationStatus;
  size?: 'sm' | 'md';
}) {
  const { t } = useTranslation('logisticsCalculations');
  return (
    <StatusBadge
      status={status === LogisticsCalculationStatus.PUBLISHED ? 'active' : 'draft'}
      label={t(`statuses.${status}`)}
      {...(size ? { size } : {})}
    />
  );
}
